import { Box } from "@mui/system";
import React from "react";
import { useParams } from "react-router-dom";
import BillPrintBody from "../../../components/PatientDetails/BillingSection/BillPrint/BillPrintBody";
import BillPrintFooter from "../../../components/PatientDetails/BillingSection/BillPrint/BillPrintFooter";
import BillPrintHeader from "../../../components/PatientDetails/BillingSection/BillPrint/BillPrintHeader";
import CardDataLoader from "../../../uiComponents/CardDataLoader/CardDataLoader";
import "./BillPrint.css";

const BillPrint = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  let slug = useParams();
  return (
    <>
      {/* <div>Bill Print </div>? */}
      <Box sx={{ position: "relative" }}>
        <BillPrintHeader></BillPrintHeader>
        <BillPrintBody slug={slug} setIsLoading={setIsLoading}></BillPrintBody>
        <BillPrintFooter></BillPrintFooter>
        {isLoading && (
          <Box sx={{ height: "100vh" }}>
            <CardDataLoader></CardDataLoader>
          </Box>
        )}
      </Box>
    </>
  );
};

export default BillPrint;
